import './article-media-video.scss';

/**
 * version    1.0
 * class      <type> (ArticleMediaVideo)
 * classdesc
 */
export class ArticleMediaVideo {}
